import { render, staticRenderFns } from "./OperationRecordList.vue?vue&type=template&id=88b56406&scoped=true&"
import script from "./OperationRecordList.vue?vue&type=script&lang=js&"
export * from "./OperationRecordList.vue?vue&type=script&lang=js&"
import style0 from "./OperationRecordList.vue?vue&type=style&index=0&id=88b56406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b56406",
  null
  
)

export default component.exports